<template>
  <v-card>
    <system-notification
      v-if="notificationPreviewContent"
      :content="notificationPreviewContent"
      @close="closeModalNotification"
    />
    <div v-else class="pa-4">
      <p>No se encontró la notificación seleccionada.</p>
    </div>
  </v-card>
</template>

<script>
  import SystemNotification from '@/components/SystemNotification.vue';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'NotificationContainer',

    components: {
      SystemNotification,
    },

    props: {
      notificationId: {
        type: [String, Number],
        default: null,
      },
    },

    computed: {
      ...mapGetters('userNotification', [
        'notificationPreviewContent',
        'selectedNotificationDetails',
      ]),
    },

    watch: {
      notificationId: {
        immediate: true,
        handler(newId) {
          if (newId) {
            this.selectNotification(newId);
          }
        },
      },
    },
    beforeDestroy() {
      this.clearSelectedNotification();
    },
    methods: {
      ...mapActions('userNotification', [
        'selectNotification',
        'clearSelectedNotification',
      ]),

      closeModalNotification() {
        this.clearSelectedNotification();
        this.$emit('closeModal');
      },
    },
  };
</script>
